module.exports = __webpack_public_path__ + "img/scienceT.e8def25c.png";